import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { useStore } from "@/stores/useStore";
import { Spinner } from "@/components/Common/Spinner";
import { useRoles } from "@/hooks/useRoles";
import { Loading } from "@/components/Page/Loading";
import { Forbidden } from "@/components/Page/Forbidden";
import { CustomerUpdatesTable } from "@/components/CustomerUpdate/CustomerUpdates.table";
import { CustomerUpdatesStats } from "@/components/CustomerUpdate/CustomerUpdatesStats";
import { useEffect, useMemo } from "react";
import { BreadcrumbPage } from "@/components/Page/BreadcrumbPage";
import { CustomerUpdatesHeader } from "@/components/Page/Header/CustomerUpdatesHeader";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { AnalyticsLocationProvider } from "@/providers/AnalyticsLocationProvider";

const CustomerUpdatesPage = () => {
  const { isSuperAdmin, isAdmin, isOffice, isInitialized } = useRoles();
  const { setHeaderContent } = useHeaderContext();
  useIsAuthenticated();
  const shopId = useStore((s) => s.shopId);
  const shop = useStore((s) => s.shop);

  const containers = useMemo(() => shop?.containers ?? [], [shop]);

  useEffect(() => {
    setHeaderContent(shopId ? <CustomerUpdatesHeader shopId={shopId} /> : null);
    return () => setHeaderContent(null);
  }, [setHeaderContent, shopId]);

  if (!shopId) {
    return (
      <div>
        <Spinner size={"lg"} />
      </div>
    );
  }

  if (!isInitialized) return <Loading />;
  if (isInitialized && !(isSuperAdmin || isAdmin || isOffice))
    return <Forbidden />;

  return (
    <BreadcrumbPage>
      <AnalyticsLocationProvider
        location={"Customer Updates Page"}
        additionalData={{
          shopId: shopId,
        }}
      >
        <CustomerUpdatesStats shopId={shopId} />
        <CustomerUpdatesTable shopId={shopId} containers={containers} />
      </AnalyticsLocationProvider>
    </BreadcrumbPage>
  );
};

export default CustomerUpdatesPage;
